import { render, staticRenderFns } from "./wmIntroduction.vue?vue&type=template&id=5459e645&scoped=true&"
import script from "./wmIntroduction.vue?vue&type=script&lang=js&"
export * from "./wmIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./wmIntroduction.vue?vue&type=style&index=0&id=5459e645&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5459e645",
  null
  
)

export default component.exports